import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'formatTime',
  standalone: true
})
export class FormatTimePipe implements PipeTransform {

  transform(value?: string): string | undefined {
    if (typeof value !== 'string') {
      return value;
    }
    else if (value) {
      const dateString = DateTime.fromISO(value, {zone: 'utc'});
      return dateString.toFormat('HH:mm');
    }
    else {
      return undefined;
    }
  }
}

@Pipe({
  name: 'formatDate',
  standalone: true
})
export class FormatDatePipe implements PipeTransform {
  
    transform(value?: string): string | undefined {
      if (typeof value !== 'string') {
        return value;
      }
      else if (value) {
        const dateString = DateTime.fromISO(value, {zone: 'utc'});
        return dateString.toFormat('dd MMM yyyy');
      }
      else {
        return undefined;
      }
    }
}

@Pipe({
  name: 'formatMinutes',
  standalone: true
})
export class FormatMinutes implements PipeTransform {

  transform(minutes: string): string {
    const hours = Math.floor(+minutes/60);
    const minutesLeft = +minutes % 60;
    return `${hours}:${minutesLeft < 10 ? '0': ''}${minutesLeft}`
  }
}

@Pipe({
  name: 'formatDateTime',
  standalone: true
})
export class FormatDateTimePipe implements PipeTransform {
  
    transform(value?: string): string | undefined {
      if (typeof value !== 'string') {
        return value;
      }
      else if (value) {
        const dateString = DateTime.fromISO(value, {zone: 'utc'});
        return dateString.toFormat('MM-dd-yyyy, HH:mm');
      }
      else {
        return undefined;
      }
    }
}